import React from 'react'

interface TestimonialAuthor {
  name: string
  designation: string
}

interface TestimonialContent {
  content: string
  author: TestimonialAuthor
}

interface TestimonialProps {
  content: TestimonialContent
}

const Testimonial: React.FC<TestimonialProps> = ({ content }) => {
  return (
    <div className="mi-testimonial-slideritem">
      <div className="mi-testimonial">
        <div className="mi-testimonial-content">
          <p>{content.content}</p>
        </div>
        <div className="mi-testimonial-author">
          <h5>{content.author.name}</h5>
          <h6>{content.author.designation}</h6>
        </div>
      </div>
    </div>
  )
}

export default Testimonial